import React, {useEffect, useState} from 'react'
import {useParams} from 'react-router-dom'
import PortfolioContainer from './PortfolioContainer'
import {getPortfolioByToken} from './core/_requests'
import {ErrorInvalidToken} from '../../modules/errors/components/ErrorInvalidToken'
import {PageTitle, PageDataProvider} from '../../../_metronic/layout/core'

const PublicPortfolio: React.FC = () => {
  const {token} = useParams<{token: string}>()
  const [projectIds, setProjectIds] = useState<string[]>([])
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState<string>('')
  const [showErrorPage, setShowErrorPage] = useState(false)

  useEffect(() => {
    // Hide the global splash screen loader
    const splashScreen = document.getElementById('splash-screen')
    if (splashScreen) {
      splashScreen.style.display = 'none'
    }

    // Remove page-loading class from body
    document.body.classList.remove('page-loading')

    // Set document title based on state
    if (showErrorPage || error) {
      document.title = 'Link Expired'
    } else {
      document.title = 'Preview Portfolio'
    }
  }, [showErrorPage, error])

  useEffect(() => {
    const fetchProjectIds = async () => {
      if (!token) {
        setError('Invalid token')
        setIsLoading(false)
        return
      }

      try {
        // Fetch project IDs using the token
        const response = await getPortfolioByToken(token)
        
        console.log('API Response:', response) // Debug log
        
        if (response.status === 200 && response.data) {
          // Extract project IDs from data array
          const ids = response.data.map((project: any) => project.id.toString())
          setProjectIds(ids)
        } else {
          setError('Invalid or expired token')
          setShowErrorPage(true)
        }
      } catch (err: any) {
        console.error('Failed to fetch portfolio by token:', err)
        console.error('Error details:', err.response?.data || err.message)
        setError('Failed to load portfolio')
        setShowErrorPage(true)
      } finally {
        setIsLoading(false)
      }
    }

    fetchProjectIds()
  }, [token])

  useEffect(() => {
    // Hide the global splash screen loader
    const splashScreen = document.getElementById('splash-screen')
    if (splashScreen) {
      splashScreen.style.display = 'none'
    }
    
    // Remove page-loading class from body
    document.body.classList.remove('page-loading')

    // Set document title directly
    document.title = 'Preview Portfolio'
  }, [])

  if (isLoading) {
    return (
      <div className='d-flex flex-column align-items-center justify-content-center vh-100'>
        <div className='spinner-border text-primary' role='status'>
          <span className='visually-hidden'>Loading...</span>
        </div>
        <div className='mt-3'>Loading portfolio...</div>
      </div>
    )
  }

  if (showErrorPage || error) {
    return (
      <PageDataProvider>
        <PageTitle breadcrumbs={[]}>Link Expired</PageTitle>
        <ErrorInvalidToken />
      </PageDataProvider>
    )
  }

  if (projectIds?.length === 0) {
    return (
      <div className='d-flex align-items-center justify-content-center vh-100'>
        <div className='alert alert-warning'>No projects found for this portfolio.</div>
      </div>
    )
  }

  return (
    <PageDataProvider>
      <PageTitle breadcrumbs={[]}>Preview Portfolio</PageTitle>
      <PortfolioContainer projectIds={projectIds} showButtons={false} isPublic={false} />
    </PageDataProvider>
  )
}

export default PublicPortfolio
